import axios from "axios";
import config  from '../../env.json';
function updatePushToken(payload,callback){

    try {
        axios.post(config.REACT_APP_NOTIFICATION_API_BASE+'/notification/update_device', payload)
        .then(res=>{ 
            console.log("----Device Token Update Response-----");
            console.log(res.data);
          debugger;
          callback(res);
        }).catch(()=>{
          debugger;
          callback([])
        })
    } catch (error) {
      debugger;
        callback([])
        
    }    
}

export {updatePushToken}